import styled from 'styled-components';

const SelectTabletsStyled = styled.div`
  width: 100%;
  font-size: 15px;
  font-weight: 400;
  color: ${(props) => props.theme.text.medium};

  .hidden {
    position: absolute;
    z-index: -1;
    border: none;
  }

  .error {
    font-size: 15px;
    font-weight: 600;
    color: ${(props) => props.theme.color.red};
  }

  .label {
    font-size: 14px !important;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .tabletContainer {
    display: flex;
    align-items: center;
    pointer-events: ${(props) => (props?.showFailureModal || props?.isExistingUser) && 'none'};

    &.is-invalid {
      div {
        border-color: ${(props) => props.theme.color.red} !important;
      }
    }

    div.active.outer {
      border-color: #1976d2;
      background: #f2f8fd;
      color: #1976d2;
      font-weight: 600;
    }

    div.outer {
      width: 50%;
      border: 1px solid ${(props) => props.theme.color.border};
      cursor: pointer;
      text-align: center;
      padding: 12px 0px;
    }

    div.labelWithImage {
      display: flex;
      align-items: center;
      justify-content: center;

      div {
        margin-left: 6px;
      }
    }

    div:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    div:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-left: none;

      &.active {
        border-left: 1px solid #1976d2;
      }
    }
  }
`;

export default SelectTabletsStyled;
